module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('lazy-component', {
    ref: "lazy",
    staticClass: "timeline-lazy-wrapper"
  }, [_c('div', {
    ref: "container",
    staticClass: "timeline-pane",
    class: {
      overlay: _vm.isOverlay
    }
  }, [_c('div', {
    staticClass: "timeline-title"
  }, [_vm._v("timeline")]), _c('div', {
    staticClass: "gradient-cover"
  }), _c('div', {
    ref: "timelineEmbed",
    staticClass: "timeline-embed ",
    attrs: {
      "id": "timeline-embed"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-515a12ca","hasScoped":false,"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/node/person/Timeline.vue
// module id = 1750
// module chunks = 1